<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g><g fill="transparent"><g><path d="M13.873 12.4H2.127l1.121-1.666.102-.152V5.25A4.655 4.655 0 0 1 7.998.602a4.657 4.657 0 0 1 4.654 4.648v5.332l.102.152 1.119 1.666z" fill="currentColor"/><path d="m12.748 11.8-.695-1.034V5.25a4.056 4.056 0 0 0-4.055-4.048A4.053 4.053 0 0 0 3.949 5.25v5.516l-.203.303-.492.73h9.494M15 13H1l1.75-2.6V5.25A5.247 5.247 0 0 1 7.998.002a5.249 5.249 0 0 1 5.254 5.248v5.15L15 13z" fill="currentColor"/></g><g stroke="transparent" stroke-width="1.2"><path stroke="none" d="M6 13.999h4a2 2 0 0 1-2 2 2 2 0 0 1-2-2z" fill="currentColor"/><path fill="none" d="M6.6 14.599h2.8a.8.8 0 0 1-.8.8H7.4a.8.8 0 0 1-.8-.8z"/></g></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-notice',
});
</script>
